import { keaPalette } from '../styles/designTokens';

// https://docs.appian.com/suite/help/20.4/ux_charts.html
// const a1 = "#015faa"
// const a2 = "#1f87ab"
// const a3 = "#45a98f"
// const a4 = "#82c272"
// const temp ={
//   light: '#82c272',
//   normal: '#45a98f',
//   dark: '#1f87ab',
//   darker: '#015faa',
// }
// https://www.tutorialrepublic.com/html-reference/html-color-picker.php
// https://maketintsandshades.com/#82c272,45a98f,1f87ab,015faa
export const chartColors = {
  main: {
    lighter: keaPalette.primarySoft,
    light: keaPalette.primaryBorder,
    normal: keaPalette.primary,
    dark: keaPalette.primaryHover,
    darker: keaPalette.primaryActive,
  },
  different: {
    lighter: '#B9D8EB',
    light: '#6FB1D6',
    normal: '#0077B6',
    dark: '#005D8F',
    darker: '#003E5E',
  },
  accent: {
    lighter: '#6fc1a2',
    light: '#4dbd96',
    normal: '#008a60',
    dark: '#00724a',
    darker: '#004d32',
  },
  howToNameIt: {
    lighter: '#63e1bd',
    light: '#35dcb1',
    normal: '#00bc8a',
    dark: '#009e6b',
    darker: '#006e47',
  },
  gray: {
    lighter: '#F9FAFB',
    light: '#F4F6F8',
    normal: '#DFE3E8',
    dark: '#C4CDD5',
    darker: '#C4CDD5',
  },
  bright: {
    green: '#82C272',
    blue: '#0086c9',
  },
};

/**
 * Search analytics visual language.
 *
 * Kept separate from the legacy chartColors scale so the merchant-facing
 * analytics surfaces can evolve without silently restyling unrelated charts.
 */
export const analyticsChartTheme = {
  ink: '#1E2248',
  muted: '#66708A',
  subtle: '#8790A5',
  grid: '#EAF3F0',
  border: '#DDEAE5',
  surface: '#FFFFFF',
  page: '#F9FFFD',
  brand: keaPalette.primary,
  brandLight: keaPalette.primarySoft,
  primaryHover: keaPalette.primaryHover,
  primaryStrong: keaPalette.primary,
  primaryDark: keaPalette.primary,
  primarySubtle: keaPalette.primarySoft,
  searches: keaPalette.primary,
  searchesFill: keaPalette.primarySoft,
  clickRate: '#4D8FD6',
  clickRateFill: '#EAF2FA',
  clickEvents: '#7C6BC4',
  clickEventsFill: '#EFEDF8',
  warning: '#B9822B',
  warningFill: '#F7F0E6',
  zeroResults: '#E06C87',
  zeroResultsFill: '#FBEDF1',
  auxiliary: '#238F9C',
  previous: '#8790A5',
};

export function formatCompactMetric(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '0';
  const absolute = Math.abs(numeric);
  if (absolute >= 1000000) return `${(numeric / 1000000).toFixed(absolute >= 10000000 ? 0 : 1)}M`;
  if (absolute >= 1000) return `${(numeric / 1000).toFixed(absolute >= 10000 ? 0 : 1)}k`;
  return numeric.toLocaleString();
}

function buildchartGradients() {
  const result = {};
  result.chartColors = {
    color1: chartColors.main.light,
    color2: chartColors.main.dark,
  };
  result.gradientMain = convertColors(chartColors.main);
  result.gradientAccent = convertColors(chartColors.accent);
  result.gradient2 = {
    color1: chartColors.main.light,
    color2: chartColors.main.dark,
  };
  result.gradient3 = {
    color1: chartColors.different.dark,
    color2: chartColors.main.light,
  };
  return result;
}

function convertColors(input) {
  return Object.keys(input).reduce((obj, key, index) => {
    obj[`color${index + 1}`] = input[key];
    return obj;
  }, {});
}

export function darkenColor(hex, percent = 10) {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const r = (num >> 16) - amt;
  const g = ((num >> 8) & 0x00FF) - amt;
  const b = (num & 0x0000FF) - amt;
  const newNum = ((r < 0 ? 0 : r) << 16) | ((g < 0 ? 0 : g) << 8) | (b < 0 ? 0 : b);
  return `#${newNum.toString(16).padStart(6, '0')}`;
}

export const chartGradients = buildchartGradients();
